import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-4 max-[640px]:flex-col max-[640px]:items-stretch" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-3 p-6"
}
const _hoisted_3 = {
  key: 0,
  class: "border-b border-[rgba(227,233,243,0.95)] bg-[#f8fbff] px-6 py-4"
}
const _hoisted_4 = { class: "grid gap-3 md:grid-cols-2 lg:grid-cols-[minmax(240px,1.4fr)_minmax(160px,0.8fr)_minmax(180px,0.9fr)_minmax(180px,0.9fr)]" }
const _hoisted_5 = { class: "min-w-0" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "min-w-0" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "min-w-0" }
const _hoisted_10 = { class: "min-w-0" }
const _hoisted_11 = {
  key: 1,
  class: "px-6 py-6"
}
const _hoisted_12 = {
  key: 2,
  class: "px-6 py-6"
}
const _hoisted_13 = { class: "grid min-h-[16rem] place-items-center rounded-[1.15rem] border border-dashed border-[rgba(218,226,238,0.95)] bg-[#fbfcff] px-6 text-center" }
const _hoisted_14 = { class: "max-w-md" }
const _hoisted_15 = {
  key: 3,
  class: "grid grid-cols-1 gap-5 p-6 lg:grid-cols-2 xl:grid-cols-3"
}
const _hoisted_16 = { class: "flex h-full flex-col gap-4" }
const _hoisted_17 = { class: "flex flex-wrap items-start justify-between gap-3" }
const _hoisted_18 = { class: "min-w-0 flex-1" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "mt-1 text-[0.84rem] font-medium text-[#6d7c97]" }
const _hoisted_21 = { class: "mt-1 truncate text-[0.88rem] text-[#6d7c97]" }
const _hoisted_22 = { class: "font-semibold text-[#1b2436]" }
const _hoisted_23 = { class: "space-y-2.5" }
const _hoisted_24 = { class: "flex items-center justify-between gap-3" }
const _hoisted_25 = { class: "text-[0.8rem] font-bold text-[#162033]" }
const _hoisted_26 = { class: "h-2 w-full overflow-hidden rounded-full bg-slate-100" }
const _hoisted_27 = { class: "grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4" }
const _hoisted_28 = { class: "mt-auto flex flex-wrap gap-2 pt-1" }
const _hoisted_29 = {
  key: 4,
  class: "flex items-center justify-between gap-4 border-t border-[rgba(227,233,243,0.95)] bg-white px-6 py-4 max-[640px]:flex-col max-[640px]:items-stretch"
}
const _hoisted_30 = { class: "text-[0.84rem] font-bold text-[#6e7b92]" }
const _hoisted_31 = { class: "flex items-center gap-3 max-[640px]:justify-between" }
const _hoisted_32 = { class: "text-[0.84rem] font-extrabold text-[#182033]" }

import { computed, ref, watch } from "vue";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { DashboardClientOverviewItem } from "@/types/dashboard";

const pageSize = 6;


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminClientOverviewTable',
  props: {
    rows: {},
    loading: { type: Boolean },
    canViewReports: { type: Boolean },
    canViewTasks: { type: Boolean }
  },
  emits: ["view-dashboard", "view-reports", "view-tasks"],
  setup(__props: any) {

const props = __props;



const searchTerm = ref("");
const selectedPackage = ref("all");
const selectedPerformance = ref("all");
const selectedSort = ref("latest");
const currentPage = ref(1);

const safeRows = computed(() => {
  return Array.isArray(props.rows) ? props.rows : [];
});

const packageOptions = computed(() => {
  const packages = new Set<string>();

  safeRows.value.forEach((row) => {
    const packageName = String(row?.package_name || "").trim();

    if (packageName) {
      packages.add(packageName);
    }
  });

  return Array.from(packages).sort((a, b) => a.localeCompare(b));
});

const filteredRows = computed(() => {
  const keyword = searchTerm.value.trim().toLowerCase();

  return safeRows.value.filter((row) => {
    const clientName = String(row?.client_name || "").toLowerCase();
    const clientRef = String(row?.client_ref || "").toLowerCase();
    const packageName = String(row?.package_name || "").toLowerCase();

    const matchesSearch =
      !keyword ||
      clientName.includes(keyword) ||
      clientRef.includes(keyword) ||
      packageName.includes(keyword);

    const matchesPackage =
      selectedPackage.value === "all" ||
      String(row?.package_name || "").trim() === selectedPackage.value;

    const completionRate = normalizedCompletionRate(row);

    const matchesPerformance =
      selectedPerformance.value === "all" ||
      (selectedPerformance.value === "high" && completionRate >= 75) ||
      (selectedPerformance.value === "medium" &&
        completionRate >= 50 &&
        completionRate < 75) ||
      (selectedPerformance.value === "low" && completionRate < 50);

    return matchesSearch && matchesPackage && matchesPerformance;
  });
});

const sortedRows = computed(() => {
  const rows = [...filteredRows.value];

  switch (selectedSort.value) {
    case "name-asc":
      return rows.sort((a, b) =>
        displayClientName(a).localeCompare(displayClientName(b))
      );

    case "name-desc":
      return rows.sort((a, b) =>
        displayClientName(b).localeCompare(displayClientName(a))
      );

    case "completion-desc":
      return rows.sort(
        (a, b) => normalizedCompletionRate(b) - normalizedCompletionRate(a)
      );

    case "completion-asc":
      return rows.sort(
        (a, b) => normalizedCompletionRate(a) - normalizedCompletionRate(b)
      );

    case "tasks-desc":
      return rows.sort(
        (a, b) => safeNumber(b?.total_tasks) - safeNumber(a?.total_tasks)
      );

    case "tickets-desc":
      return rows.sort(
        (a, b) => safeNumber(b?.active_tickets) - safeNumber(a?.active_tickets)
      );

    case "latest":
    default:
      return rows;
  }
});

const totalPages = computed(() => {
  return Math.max(1, Math.ceil(sortedRows.value.length / pageSize));
});

const paginatedRows = computed(() => {
  const start = (currentPage.value - 1) * pageSize;
  const end = start + pageSize;

  return sortedRows.value.slice(start, end);
});

const showingStart = computed(() => {
  if (!filteredRows.value.length) return 0;

  return (currentPage.value - 1) * pageSize + 1;
});

const showingEnd = computed(() => {
  if (!filteredRows.value.length) return 0;

  return Math.min(currentPage.value * pageSize, filteredRows.value.length);
});

watch([searchTerm, selectedPackage, selectedPerformance, selectedSort], () => {
  currentPage.value = 1;
});

watch(totalPages, (pageCount) => {
  if (currentPage.value > pageCount) {
    currentPage.value = pageCount;
  }
});

function goToPrevPage() {
  if (currentPage.value > 1) {
    currentPage.value -= 1;
  }
}

function goToNextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value += 1;
  }
}

function resetFilters() {
  searchTerm.value = "";
  selectedPackage.value = "all";
  selectedPerformance.value = "all";
  selectedSort.value = "latest";
  currentPage.value = 1;
}

function displayClientName(row: DashboardClientOverviewItem) {
  return String(row?.client_name || "").trim() || "Unnamed Client";
}

function displayClientRef(row: DashboardClientOverviewItem) {
  return String(row?.client_ref || "").trim() || "Unknown ID";
}

function displayPackageName(row: DashboardClientOverviewItem) {
  return String(row?.package_name || "").trim() || "-";
}

function safeNumber(value: unknown) {
  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : 0;
}

function normalizedCompletionRate(row: DashboardClientOverviewItem) {
  const rate = safeNumber(row?.completion_rate);

  return Math.max(0, Math.min(100, Number(rate.toFixed(2))));
}

function clientMetricCards(row: DashboardClientOverviewItem) {
  return [
    { label: "Services", value: safeNumber(row?.active_services_count) },
    { label: "Tasks", value: safeNumber(row?.total_tasks) },
    { label: "In Progress", value: safeNumber(row?.in_progress) },
    { label: "Completed", value: safeNumber(row?.completed) },
    { label: "Overdue", value: safeNumber(row?.overdue) },
    { label: "Tickets", value: safeNumber(row?.active_tickets) },
    { label: "Leads", value: safeNumber(row?.new_leads) },
  ];
}

function rateClass(rate: number) {
  if (rate >= 76) return "bg-emerald-50 text-emerald-700 border-emerald-100";
  if (rate >= 51) return "bg-blue-50 text-blue-700 border-blue-100";
  if (rate >= 26) return "bg-amber-50 text-amber-700 border-amber-100";

  return "bg-orange-50 text-orange-700 border-orange-100";
}

function completionBarClass(rate: number) {
  if (rate >= 76) return "bg-emerald-500";
  if (rate >= 51) return "bg-blue-500";
  if (rate >= 26) return "bg-amber-500";

  return "bg-orange-500";
}

function metricCardClass(label: string) {
  switch (label) {
    case "Services":
      return "border-slate-100 bg-slate-50/80 hover:border-slate-200";
    case "Tasks":
      return "border-blue-100 bg-blue-50/80 hover:border-blue-200";
    case "In Progress":
      return "border-purple-100 bg-purple-50/80 hover:border-purple-200";
    case "Completed":
      return "border-emerald-100 bg-emerald-50/80 hover:border-emerald-200";
    case "Overdue":
      return "border-orange-100 bg-orange-50/80 hover:border-orange-200";
    case "Tickets":
      return "border-cyan-100 bg-cyan-50/80 hover:border-cyan-200";
    case "Leads":
      return "border-pink-100 bg-pink-50/80 hover:border-pink-200";
    default:
      return "border-slate-100 bg-slate-50/80 hover:border-slate-200";
  }
}

function metricLabelClass(label: string) {
  switch (label) {
    case "Services":
      return "text-slate-600";
    case "Tasks":
      return "text-blue-700";
    case "In Progress":
      return "text-purple-700";
    case "Completed":
      return "text-emerald-700";
    case "Overdue":
      return "text-orange-700";
    case "Tickets":
      return "text-cyan-700";
    case "Leads":
      return "text-pink-700";
    default:
      return "text-slate-600";
  }
}

function metricValueClass(label: string) {
  switch (label) {
    case "Services":
      return "text-slate-900";
    case "Tasks":
      return "text-blue-950";
    case "In Progress":
      return "text-purple-950";
    case "Completed":
      return "text-emerald-950";
    case "Overdue":
      return "text-orange-950";
    case "Tickets":
      return "text-cyan-950";
    case "Leads":
      return "text-pink-950";
    default:
      return "text-slate-900";
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "flex h-full min-w-0 flex-col overflow-hidden rounded-[1.35rem] border border-[rgba(218,226,238,0.95)] bg-gradient-to-b from-white to-[#fbfcff] shadow-[0_20px_40px_rgba(15,23,42,0.05)]" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), { class: "border-b border-[rgba(227,233,243,0.95)] bg-white px-6 py-5" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createVNode(_unref(CardTitle), { class: "m-0 text-[1.2rem] font-extrabold text-[#182033]" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Client Overview ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(CardDescription), { class: "mt-[0.35rem] text-[#6e7b92]" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Assigned-client performance summary. ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(CardContent), { class: "flex-1 p-0" }, {
        default: _withCtx(() => [
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                  return _createVNode(_unref(Skeleton), {
                    key: n,
                    class: "h-[12rem] rounded-[1.15rem] bg-stone-100"
                  })
                }), 64))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (safeRows.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _cache[7] || (_cache[7] = _createElementVNode("label", {
                            for: "client-overview-search",
                            class: "mb-1.5 block text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-[#6f7d94]"
                          }, " Search Clients ", -1)),
                          _createElementVNode("div", _hoisted_6, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#8a98ad]" }, [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d: "m21 21-4.35-4.35m1.35-5.15a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z"
                                })
                              ])
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                              id: "client-overview-search",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
                              type: "search",
                              placeholder: "Search by company name or ID...",
                              class: "h-11 w-full rounded-[0.95rem] border border-[rgba(203,216,235,0.95)] bg-white pl-10 pr-3 text-[0.88rem] font-medium text-[#182033] outline-none transition placeholder:text-[#8c99af] focus:border-[#8db8ff] focus:ring-4 focus:ring-[#dceaff]"
                            }, null, 512), [
                              [_vModelText, searchTerm.value]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _cache[9] || (_cache[9] = _createElementVNode("label", {
                            for: "client-overview-package",
                            class: "mb-1.5 block text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-[#6f7d94]"
                          }, " Package Type ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "client-overview-package",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPackage).value = $event)),
                            class: "h-11 w-full rounded-[0.95rem] border border-[rgba(203,216,235,0.95)] bg-white px-3 text-[0.88rem] font-bold text-[#182033] outline-none transition focus:border-[#8db8ff] focus:ring-4 focus:ring-[#dceaff]"
                          }, [
                            _cache[8] || (_cache[8] = _createElementVNode("option", { value: "all" }, " All Plans ", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageOptions.value, (packageName) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: packageName,
                                value: packageName
                              }, _toDisplayString(packageName), 9, _hoisted_8))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, selectedPackage.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _cache[11] || (_cache[11] = _createElementVNode("label", {
                            for: "client-overview-performance",
                            class: "mb-1.5 block text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-[#6f7d94]"
                          }, " Performance ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "client-overview-performance",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedPerformance).value = $event)),
                            class: "h-11 w-full rounded-[0.95rem] border border-[rgba(203,216,235,0.95)] bg-white px-3 text-[0.88rem] font-bold text-[#182033] outline-none transition focus:border-[#8db8ff] focus:ring-4 focus:ring-[#dceaff]"
                          }, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("option", { value: "all" }, " All Performance ", -1),
                            _createElementVNode("option", { value: "high" }, " High Completion ", -1),
                            _createElementVNode("option", { value: "medium" }, " Medium Completion ", -1),
                            _createElementVNode("option", { value: "low" }, " Low Completion ", -1)
                          ]))], 512), [
                            [_vModelSelect, selectedPerformance.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _cache[13] || (_cache[13] = _createElementVNode("label", {
                            for: "client-overview-sort",
                            class: "mb-1.5 block text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-[#6f7d94]"
                          }, " Sort By ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "client-overview-sort",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedSort).value = $event)),
                            class: "h-11 w-full rounded-[0.95rem] border border-[rgba(203,216,235,0.95)] bg-white px-3 text-[0.88rem] font-bold text-[#182033] outline-none transition focus:border-[#8db8ff] focus:ring-4 focus:ring-[#dceaff]"
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("option", { value: "latest" }, " Latest ", -1),
                            _createElementVNode("option", { value: "name-asc" }, " Client Name A-Z ", -1),
                            _createElementVNode("option", { value: "name-desc" }, " Client Name Z-A ", -1),
                            _createElementVNode("option", { value: "completion-desc" }, " Completion High-Low ", -1),
                            _createElementVNode("option", { value: "completion-asc" }, " Completion Low-High ", -1),
                            _createElementVNode("option", { value: "tasks-desc" }, " Tasks High-Low ", -1),
                            _createElementVNode("option", { value: "tickets-desc" }, " Tickets High-Low ", -1)
                          ]))], 512), [
                            [_vModelSelect, selectedSort.value]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!safeRows.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("div", { class: "grid min-h-[16rem] place-items-center rounded-[1.15rem] border border-dashed border-[rgba(218,226,238,0.95)] bg-[#fbfcff] px-6 text-center" }, [
                        _createElementVNode("div", { class: "max-w-md" }, [
                          _createElementVNode("p", { class: "text-[1rem] font-bold text-[#182033]" }, " No client overview data yet. "),
                          _createElementVNode("p", { class: "mt-2 text-[0.92rem] leading-7 text-[#6e7b92]" }, " Client analytics will populate once assigned accounts have activity. ")
                        ])
                      ], -1)
                    ]))]))
                  : (!filteredRows.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-[1rem] font-bold text-[#182033]" }, " No matching clients found. ", -1)),
                            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mt-2 text-[0.92rem] leading-7 text-[#6e7b92]" }, " Try adjusting your search or filters. ", -1)),
                            _createVNode(_unref(Button), {
                              variant: "outline",
                              class: "mt-4 rounded-[0.9rem] border-[rgba(49,125,255,0.22)] bg-[#f6f9ff] px-4 text-[0.82rem] font-bold text-[#2855a6] hover:bg-[#eef4ff]",
                              onClick: resetFilters
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode(" Reset Filters ", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedRows.value, (row) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: row.client_ref || row.client_name,
                            class: "group rounded-2xl border border-[rgba(218,226,238,0.95)] bg-white p-4 shadow-[0_14px_30px_rgba(15,23,42,0.04)] transition-all duration-200 ease-out hover:-translate-y-0.5 hover:border-[#c8daf7] hover:shadow-[0_18px_34px_rgba(15,23,42,0.08)]"
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("p", {
                                    class: "truncate text-[1.02rem] font-extrabold tracking-[-0.01em] text-[#162033]",
                                    title: displayClientName(row)
                                  }, _toDisplayString(displayClientName(row)), 9, _hoisted_19),
                                  _createElementVNode("p", _hoisted_20, " Client ID " + _toDisplayString(displayClientRef(row)), 1),
                                  _createElementVNode("p", _hoisted_21, [
                                    _cache[18] || (_cache[18] = _createTextVNode(" Package: ", -1)),
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(displayPackageName(row)), 1)
                                  ])
                                ]),
                                _createVNode(_unref(Badge), {
                                  variant: "outline",
                                  class: _normalizeClass(["rounded-full border px-3 py-[0.4rem] text-[0.76rem] font-extrabold whitespace-nowrap shadow-sm transition-all duration-200 ease-out", rateClass(normalizedCompletionRate(row))])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Completion " + _toDisplayString(normalizedCompletionRate(row)) + "% ", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-[0.68rem] font-extrabold uppercase tracking-[0.14em] text-[#6f7d94]" }, " Completion Progress ", -1)),
                                  _createElementVNode("p", _hoisted_25, _toDisplayString(normalizedCompletionRate(row)) + "% ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["h-full rounded-full transition-all duration-300 ease-out", completionBarClass(normalizedCompletionRate(row))]),
                                    style: _normalizeStyle({ width: `${normalizedCompletionRate(row)}%` })
                                  }, null, 6)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientMetricCards(row), (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.label,
                                    class: _normalizeClass(["rounded-xl border px-3 py-3 shadow-sm transition-all duration-200 ease-out hover:-translate-y-0.5 hover:shadow-md", metricCardClass(item.label)])
                                  }, [
                                    _createElementVNode("p", {
                                      class: _normalizeClass(["text-[0.66rem] font-extrabold uppercase tracking-[0.12em] whitespace-nowrap", metricLabelClass(item.label)])
                                    }, _toDisplayString(item.label), 3),
                                    _createElementVNode("p", {
                                      class: _normalizeClass(["mt-1 text-[1.02rem] font-extrabold tracking-[-0.01em] whitespace-nowrap", metricValueClass(item.label)])
                                    }, _toDisplayString(item.value), 3)
                                  ], 2))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_unref(Button), {
                                  variant: "outline",
                                  class: "inline-flex min-h-10 items-center gap-2 rounded-[0.9rem] border-[rgba(49,125,255,0.22)] bg-[#f6f9ff] px-[0.8rem] py-[0.55rem] text-[0.8rem] font-bold text-[#2855a6] transition-all duration-200 ease-out hover:-translate-y-0.5 hover:border-[#96beff] hover:bg-[#edf4ff] hover:shadow-sm active:translate-y-0 active:scale-[0.98]",
                                  onClick: ($event: any) => (_ctx.$emit('view-dashboard', row))
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode(" View Dashboard ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]),
                                (props.canViewReports !== false)
                                  ? (_openBlock(), _createBlock(_unref(Button), {
                                      key: 0,
                                      variant: "outline",
                                      class: "inline-flex min-h-10 items-center gap-2 rounded-[0.9rem] border-[rgba(49,125,255,0.22)] bg-[#f6f9ff] px-[0.8rem] py-[0.55rem] text-[0.8rem] font-bold text-[#2855a6] transition-all duration-200 ease-out hover:-translate-y-0.5 hover:border-[#96beff] hover:bg-[#edf4ff] hover:shadow-sm active:translate-y-0 active:scale-[0.98]",
                                      onClick: ($event: any) => (_ctx.$emit('view-reports', row))
                                    }, {
                                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                        _createTextVNode(" View Reports ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (props.canViewTasks !== false)
                                  ? (_openBlock(), _createBlock(_unref(Button), {
                                      key: 1,
                                      class: "inline-flex min-h-10 items-center gap-2 rounded-[0.9rem] bg-[#1f7aff] px-[0.8rem] py-[0.55rem] text-[0.8rem] font-bold text-white transition-all duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#1f7aff] hover:shadow-[0_12px_24px_rgba(31,122,255,0.24)] active:translate-y-0 active:scale-[0.98]",
                                      onClick: ($event: any) => (_ctx.$emit('view-tasks', row))
                                    }, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createTextVNode(" View Tasks ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])),
                (safeRows.value.length && filteredRows.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("p", _hoisted_30, " Showing " + _toDisplayString(showingStart.value) + "-" + _toDisplayString(showingEnd.value) + " of " + _toDisplayString(filteredRows.value.length) + " clients ", 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_unref(Button), {
                          variant: "outline",
                          class: "min-h-9 rounded-[0.8rem] border-[rgba(49,125,255,0.18)] bg-[#f8fbff] px-3 text-[0.78rem] font-bold text-[#2855a6] disabled:cursor-not-allowed disabled:opacity-45",
                          disabled: currentPage.value === 1,
                          onClick: goToPrevPage
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createTextVNode(" Prev ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createElementVNode("span", _hoisted_32, " Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(totalPages.value), 1),
                        _createVNode(_unref(Button), {
                          variant: "outline",
                          class: "min-h-9 rounded-[0.8rem] border-[rgba(49,125,255,0.18)] bg-[#f8fbff] px-3 text-[0.78rem] font-bold text-[#2855a6] disabled:cursor-not-allowed disabled:opacity-45",
                          disabled: currentPage.value === totalPages.value,
                          onClick: goToNextPage
                        }, {
                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createTextVNode(" Next ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})